<script>
import VueWithCompiler from "vue/dist/vue.esm";
import draggable from "vuedraggable";
import moment from "moment";

// Custom Components
import UserService from "@/helpers/APIService/user.service";
import errorHandler from "@/helpers/errorHandler";
import Middleware from "@/helpers/middlewares";
import { authComputed } from "@/state/helpers";

export default {
  props: {
    html: {
      type: String,
    },
    Pages: {
      type: Array,
    },
  },
  data() {
    return {
      enabled: true,
      dragging: false,
      PageData: [],
      isOnTemplate: true,
      isShowAddNew: false,
    };
  },
  components: {
    draggable,
  },
  computed: {
    ...authComputed,
  },
  watch: {
    html(to) {
      this.updateRender();
    },
  },
  created() {
    this.updateRender();
  },
  mounted() {
    this.$root.$on("changeTemMode", (data) => {
      this.isOnTemplate = data;
    });
    this.$root.$on("updateMenuData", (data) => {
      this.PageData = data;
      this.$forceUpdate();
    });
  },
  methods: {
    updateRender() {
      if (localStorage.isOnTemplate !== undefined) {
        this.isOnTemplate =
          localStorage.getItem("isOnTemplate") == "false" ? false : true;
      }
      let index = 0;
      const featureCodes = [102, 106, 112, 113, 114, 116, 117];
      this.Pages.map((item) => {
        if (item.is_active) {
          if (featureCodes.includes(item.feature_code)) {
            item = { ...item, isShowEdit: false };
          } else {
            item = { ...item, isShowEdit: true, extraIndex: index };
            index += 1;
          }
          this.PageData.push(item);
        }
      });
      this.PageData.map((item) => {
        if (item.feature_code == 101) {
          if (
            item.is_active_super_panel &&
            item.is_plan_purchased &&
            item.is_active
          ) {
            if (item.end_date !== null) {
              if (
                moment().format("YYYY-MM-DD") !==
                moment(item.end_date).format("YYYY-MM-DD")
              ) {
                this.isShowAddNew = true;
              }
            } else {
              this.isShowAddNew = true;
            }
          }
        }
      });
      const compiled = VueWithCompiler.compile(this.html);
      this.templateRender = compiled.render;
      this.$options.staticRenderFns = [];
      for (const staticRenderFunction of compiled.staticRenderFns) {
        this.$options.staticRenderFns.push(staticRenderFunction);
      }
    },
    // Method is use for get static image and return to use in image tag
    getImage(image) {
      return image !== null
        ? `url(${image})`
        : `url(${require("@/assets/images/placeholder.png")})`;
    },
    // Method is use for open category
    openCategory(data) {
      this.$root.$emit("openCategory", data);
    },
    // Method is use for open update single menu
    editPage(menu, status, index) {
      this.$root.$emit("editPage", { menu, status, index });
    },
    // Method is use for open delete single menu
    deletePage(menu) {
      this.$root.$emit("deletePage", { menu });
    },
    // Method is use for open add single menu
    addPage() {
      this.$root.$emit("addPage");
    },
    // Method is use for handle position change event
    afterMove: function (evt) {
      const menuData = new FormData();
      menuData.append("priority_order", evt.moved.newIndex + 1);
      UserService.updateMenu(evt.moved.element.id, menuData)
        .then(() => {
          Middleware.notification("Position changed !!", "success");
        })
        .catch((error) => {
          errorHandler(error);
        });
      this.$root.$emit("categoryMove");
      this.PageData = this.PageData.map((item) => {
        if (item.id == evt.moved.element.id) {
          item.position = evt.moved.newIndex;
        }
        return item;
      });
    },
    openDropdown(data) {
      const featureCodes = [118, 119, 120];
      if (!featureCodes.includes(data.feature_code)) {
        this.$root.$emit("onTemplate");
      }
      if (data.isShowEdit) {
        if (this.$refs.myDropdown[data.extraIndex - 1] !== undefined) {
          this.$refs.myDropdown[data.extraIndex - 1].show();
        }
      }
    },
  },
  render() {
    return this.templateRender();
  },
};
</script>

<style scoped>
.second-template,
.new-second-template {
  height: 100px;
  border-radius: 8px;
  background-size: cover;
  background-position: center;
  position: relative;
}
.second-template::before,
.third-template::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  opacity: 0.4;
  border-radius: 8px;
  background-color: var(--template-menu-bg);
}

.third-template,
.New-add-third-template {
  width: 100%;
  height: 180px;
  border-radius: 8px;
  background-size: cover;
  background-position: center;
}
.bg-template-text {
  position: absolute;
  bottom: 0px;
  padding: 8px;
}
</style>
*
